'use strict';/* global define */define('modules/core/modules/ui-router/config',['require','exports','module','./config/$state-decorator'],function(require,exports,module){'use strict';// @ngInject
config.$inject = ["$provide"];
function config($provide){$provide.decorator('$state',require('./config/$state-decorator'));}module.exports=config;});
